<template>
    <edit-datetime
        ref="input"
        v-model="inputValue"
        form
        :disabled="disabled"
        :required="required"
        :rules="rulesValue"
        :error-messages="errorMessagesValue"
        :label="labelValue || $t('date')"
        :hide-details="hideDetails"
        :hide-label="hideLabel"
        :readonly="readonly"
        :preset-time="presetTime"
        :clearable="clearable"
        @focus="$emit('focus')"
        @blur="$emit('blur')"
        @keyup="$emit('keyup')"
        @keydown="$emit('keydown')"
        @click="$emit('click')"
    >
        <template #prepend>
            <slot name="prepend" />
        </template>
        <template #prepend-inner>
            <slot name="prepend-inner" />
        </template>
        <template #append>
            <slot name="append" />
        </template>
        <template #append-outer>
            <slot name="append-outer" />
        </template>
    </edit-datetime>
</template>

<script>
import BaseField from './BaseField';
export default {
    name: 'Datetime',
    extends: BaseField,
    props: {
        presetTime: {
            type: String,
            default: null
        }
    }
};
</script>
